import {
  IconButton,
  IconButtonSize,
  IconButtonVariant
} from "shared/components";
import { NotesList } from "./NotesList";
import Drawer from "react-modern-drawer";
import { useNotesController } from "shared/queries/useNotesController";
import { Loader } from "shared/components/Loader";
import { useMedia } from "shared/providers";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Application } from "types/application";
import { useMemo } from "react";
import { getFullName } from "shared/utils/get-full-name";

export const Notes = ({
  showNotes,
  setShowNotes,
  application,
  onNoteChange,
  showViewApplicationButton,
  notesController: _notesController,
  onMarkReadSuccess
}: {
  showNotes: boolean;
  setShowNotes: (value: boolean) => void;
  application: Application;
  onNoteChange?: () => void;
  showViewApplicationButton?: boolean;
  notesController?: ReturnType<typeof useNotesController>;
  onMarkReadSuccess?: () => void;
}) => {
  const internalNotesController = useNotesController(
    String(application.id),
    onNoteChange
  );
  const notesController = _notesController ?? internalNotesController;

  const { isMobile } = useMedia();

  const applicantsText = useMemo(() => {
    return application.applicants
      .map((applicant) => {
        return getFullName({
          firstName: applicant.first_name,
          lastName: applicant.last_name,
          middleName: applicant.middle_name
        });
      })
      .join(", ");
  }, [application.applicants]);

  return (
    <Drawer
      className="rounded-l-lg z-50"
      direction="right"
      onClose={() => {
        setShowNotes(false);
      }}
      open={showNotes}
      size={isMobile ? 380 : 500}
    >
      <div className="flex h-screen flex-col">
        <div className="flex items-center justify-between border-b border-alpha-80 px-6 py-4">
          <p className="text-xl font-bold text-content-1000">Notes</p>
          <IconButton
            onClick={() => setShowNotes(false)}
            variant={IconButtonVariant.TEXT_BASE}
            size={IconButtonSize.SM}
            HugeIcon={Cancel01Icon}
            className="stroke-content-1000"
          />
        </div>

        <div className="flex-grow overflow-y-auto">
          {notesController.notesMeta.isLoading ? (
            <div className="flex items-center justify-center pt-10">
              <Loader />
            </div>
          ) : (
            <NotesList
              propertyName={application.property.name}
              notesController={notesController}
              applicationId={String(application.id)}
              applicationStatus={application.status}
              applicantsNames={applicantsText}
              showViewApplicationButton={showViewApplicationButton}
              onMarkReadSuccess={onMarkReadSuccess}
            />
          )}
        </div>
      </div>
    </Drawer>
  );
};
